module.exports = __webpack_public_path__ + "static/media/dispo11.80cb3423.png";